
import { installSafeBtoa } from './safeBtoa';
import { configureAxiosCsrf } from './csrf';

/**
 * Import axios globally. CSRF is sent per-request from the live XSRF-TOKEN cookie
 * (see resources/js/csrf.js) — not from a frozen page-load meta tag.
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

configureAxiosCsrf(window.axios);

const funnel = document.head.querySelector('meta[name="f"]');
if (funnel) {
	window.axios.defaults.headers.common['FROM-FUNNEL'] = funnel.content;
}

installSafeBtoa(window);
